/* eslint-disable no-unused-vars */
export class CookerDatabase {

    /**
     * Search database for cookers matching the spec.
     * TODO: Make sure to clear blob URLs if needed.
     * @return {Promise<Object[]>}
     */
    query(search){
        //PouchDB - Fetch documnt, then filter, then fetch image attachments and blob url
        //fetch - fetch JSON, filter, fetch images
        throw new Error('not implemented');
    }

    getCookerHoodsFor(cookerId){
        throw new Error('not implemented');
    }
    
    /**
     * @callback UpdateCallback
     * @param {number} current
     * @param {number} total
     * @param {string} currentItemName
     */

    /**
     * @param {UpdateCallback} progressCallback
     * Prep database for offline access
     */
    update(progressCallback = null){
        //pouchDB - fetch json, parse and fetch missing images, update document.
        //fetch - fetch whole json, parse and fetch missing images.
        throw new Error('not implemented');
    }
    
    /**
     * Get the release date of the last update
     */
    lastUpdate(){
        //TODO: return version/release date of current list
        throw new Error('not implemented');
    }

    /**
     * Check if an update is available
     */
    updateAvailable(){
        throw new Error('not implemented');
    }

    isFirstRun(){
        throw new Error('not implemented');
    }

    getName(){
        throw new Error('not implemented');
    }
    
}


// WEBPACK FOOTER //
// ./src/api/backend/base.js